import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M22.5 21.25h-21a1.25 1.25 0 0 0 0 2.5h21a1.25 1.25 0 0 0 0-2.5M2 2.75h1.34a.25.25 0 0 1 .25.25v8.52a8.41 8.41 0 0 0 16.82 0V3a.25.25 0 0 1 .25-.25H22a1.25 1.25 0 0 0 0-2.5h-5.7a1.25 1.25 0 0 0 0 2.5h1.36a.25.25 0 0 1 .25.25v8.52a5.91 5.91 0 0 1-11.82 0V3a.25.25 0 0 1 .25-.25H7.7a1.25 1.25 0 0 0 0-2.5H2a1.25 1.25 0 0 0 0 2.5"
    }, null, -1)
  ]));
}
const EditorUnderline = { render };
export {
  EditorUnderline as default,
  render
};
//# sourceMappingURL=EditorUnderline.svg.js.map
